import React from 'react';
import Icon from '../../../../components/AppIcon';

const PunchInSummary = ({ punchInData, currentDuration }) => {
  const formatTime = (date) => {
    return new Date(date)?.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const formatDuration = (milliseconds) => {
    const hours = Math.floor(milliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours}h ${minutes}m`;
  };

  if (!punchInData) return null;

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 p-4 md:p-6 border border-border">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Clock" size={20} className="md:w-6 md:h-6 text-primary" />
        </div>
        <div>
          <h2 className="text-base md:text-lg font-semibold text-foreground">Punch In Summary</h2>
          <p className="text-xs md:text-sm text-muted-foreground">Your current work session</p>
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">
        <div className="flex items-start gap-3 p-3 md:p-4 bg-muted/50 rounded-lg">
          <Icon name="LogIn" size={18} className="text-primary mt-1 md:w-5 md:h-5" />
          <div className="flex-1 min-w-0">
            <p className="text-xs md:text-sm text-muted-foreground mb-1">Punched In At</p>
            <p className="text-sm md:text-base font-semibold text-foreground">{formatTime(punchInData.punchInTime)}</p>
            <p className="text-xs md:text-sm text-muted-foreground mt-1">
              {new Date(punchInData.punchInTime)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3 p-3 md:p-4 bg-muted/50 rounded-lg">
          <Icon name="MapPin" size={18} className="text-primary mt-1 md:w-5 md:h-5" />
          <div className="flex-1 min-w-0">
            <p className="text-xs md:text-sm text-muted-foreground mb-1">Punch In Location</p>
            <p className="text-sm md:text-base font-medium text-foreground break-words">{punchInData.address}</p>
            {punchInData.latitude && punchInData.longitude && (
              <p className="text-xs text-muted-foreground mt-1">
                {typeof punchInData.latitude === 'number' ? punchInData.latitude.toFixed(6) : parseFloat(punchInData.latitude).toFixed(6)}, {typeof punchInData.longitude === 'number' ? punchInData.longitude.toFixed(6) : parseFloat(punchInData.longitude).toFixed(6)}
              </p>
            )}
          </div>
        </div>

        <div className="flex items-start gap-3 p-3 md:p-4 bg-primary/5 rounded-lg border border-primary/20">
          <Icon name="Timer" size={18} className="text-primary mt-1 md:w-5 md:h-5" />
          <div className="flex-1 min-w-0">
            <p className="text-xs md:text-sm text-muted-foreground mb-1">Current Work Duration</p>
            <p className="text-lg md:text-2xl font-bold text-primary">{formatDuration(currentDuration)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PunchInSummary;

